import React from 'react';
import styled from 'styled-components/macro';
import { GraphqlPlayground } from '../components/GraphqlPlayground';

interface SchemaPlaygroundProps {
  url: string;
}
export const SchemaPlayground = ({ url }: SchemaPlaygroundProps) => (
  <StyledWrapper>
    <GraphqlPlayground url={url} />
  </StyledWrapper>
);

const StyledWrapper = styled.div`
  flex: 1;
  overflow: auto;
`;
